module.exports = __webpack_public_path__ + "img/finalforms.0997b021.jpg";